export default __webpack_public_path__ + "static/media/error_image.b62f10d5.svg";